import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProjectTemplatePostDto } from 'api/dto/ProjectTemplate.dto';
import { projectTemplateApi } from 'container/projectTemplateApi';
import { STORE_NAME } from 'reduxStore/pulseLifecycle/initialState';
import { serializeError } from 'shared/utils/redux';

export const fetchProjectTemplateList = createAsyncThunk(
  `${STORE_NAME}/fetchProjectTemplateList`,
  () => projectTemplateApi.list(),
  { serializeError },
);

export const fetchCurrentProjectTemplate = createAsyncThunk(
  `${STORE_NAME}/fetchCurrentProjectTemplate`,
  ({ currentProjectTemplateId }: { currentProjectTemplateId: number }) =>
    projectTemplateApi.get(currentProjectTemplateId),
  { serializeError },
);

export const createProjectTemplate = createAsyncThunk(
  `${STORE_NAME}/createProjectTemplate`,
  (data: ProjectTemplatePostDto) => projectTemplateApi.create(data),
  { serializeError },
);

export const adaptProjectTemplate = createAsyncThunk(
  `${STORE_NAME}/adaptProjectTemplate`,
  ({
    sourceProjectId,
    destinationProjectId,
  }: {
    sourceProjectId: number;
    destinationProjectId: number;
  }) => projectTemplateApi.adapt(sourceProjectId, destinationProjectId),
  { serializeError },
);

export const adaptPreviousSurvey = createAsyncThunk(
  `${STORE_NAME}/adaptPreviousSurvey`,
  ({
    sourceProjectId,
    destinationProjectId,
  }: {
    sourceProjectId: number;
    destinationProjectId: number;
  }) => projectTemplateApi.adaptPrevious(sourceProjectId, destinationProjectId),
  { serializeError },
);
